import {Button} from 'primereact/button'
import {Tag} from 'primereact/tag'
import React, {Fragment} from 'react'
import {FileTypeIcon} from '../icon/FileTypeIcon'

export function uploadFileTemplate(onTemplateRemove: (file: any, callback: any) => void) {
	const itemTemplate = (file: any, properties: any): JSX.Element => {
		const fileExt = file.name?.split('.').pop()?.toLowerCase()
		let fileRepresentation = FileTypeIcon(fileExt)
		if (!fileRepresentation) {
			fileRepresentation = <img alt={''} role="presentation" src={file.objectURL} className={'file-icon'}/>
		}
		return (
			<Fragment>
				<div className="flex align-items-center flex-wrap card-container">
					<div className={'file-icon-box flex justify-content-center flex-wrap card-container'}>
						{fileRepresentation}
					</div>
					<span className="text-left ml-2 ">
						{file.name}
					</span>
				</div>
				<Tag value={properties.formatSize} severity={'info'} rounded={true} className="px-2 py-1  mr-2"/>
				<Button
					type="button"
					icon="pi pi-times"
					className="p-button-danger p-button-text"
					onClick={() => onTemplateRemove(file, properties.onRemove)}/>
			</Fragment>
		)
	}
	return itemTemplate
}